import React, { useContext, useEffect, useState } from "react";
import style from "./Chats.module.css";
import { BsPeople } from "react-icons/bs";
import { MdLogout, MdWbTwilight } from "react-icons/md";
import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { auth, db } from "../../firebase/config";
import { Authcontext } from "../context/Authcontext";
import Everychat from "./Everychat";
import { signOut } from "firebase/auth";
import { NavLink, useNavigate } from "react-router-dom";
import Onlysupervisor from "../admin/Onlysupervisor";
import Onlysupport from "../admin/Onlysupport";
import { PiChatsCircle } from "react-icons/pi";
import { Chatcontext } from "../context/Chatcontext";
const Chats = () => {
  const [chats, setChats] = useState([]);
  const { currentuser } = useContext(Authcontext);
  const chatcontext = useContext(Chatcontext);
  const navigate = useNavigate();
  useEffect(() => {
    async function fetchGroupByUserID() {
      const querySnapshot = await getDocs(
        collection(db, "roomuser")
      );
      const demo = [];
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data()?.users);
        doc.data()?.users?.map((user)=>{
            if(user?.user_id === currentuser?.uid){
                console.log(doc?.data())
                demo.push(doc.data())
            }
        })

      });
      setChats([...chats, ...demo]);
      // const groupRef = collection(db, 'roomuser');
      // console.log(groupRef)
      // const q = query(groupRef, where('users', 'array-contains', { user_id: currentuser.uid }));
      // const unsubscribe = onSnapshot(q, (querySnapshot) => {
      //     const demo = [];
      //     querySnapshot.forEach((doc) => {
      //         const data = doc.data();
      //         console.log(doc.data())
      //         const userIndex = data.users.findIndex(user => user.user_id === currentuser.uid);
      //         if (userIndex !== -1) {
      //             demo.push(data);
      //         }
      //     });
      //     setChats([...chats, ...demo]);
      // });
    }
    currentuser.uid && fetchGroupByUserID();
  }, [currentuser?.uid]);
  const logoutUser = () => {
    chatcontext.changechat("null");
    signOut(auth).then(() => {
      navigate("/");
    });
  };
  return (
    <div className={style.chatscontinar}>
      <div className={style.cardicon}>
        <MdLogout
          onClick={logoutUser}
          style={{ cursor: "pointer" }}
          size={40}
        />
        <BsPeople size={40} />
      </div>
      <Onlysupervisor>
        <NavLink
          to="adminpermission"
          className={({ isActive }) => (isActive ? style.active : "")}>
          الاذونات
          <MdWbTwilight size={48} />
        </NavLink>{" "}
      </Onlysupervisor>
      <Onlysupport>
        <NavLink
          to="adminchats"
          className={({ isActive }) => (isActive ? style.active : "")}>
          المجموعات
          <PiChatsCircle size={48} />
        </NavLink>
      </Onlysupport>
      <div className={style.chats}>
        {chats.map((chat) => {
          return <Everychat key={chat.uid} chat={chat} />;
        })}
      </div>
    </div>
  );
};
export default Chats;
